import { render, staticRenderFns } from "./segmented-control.vue?vue&type=template&id=b85fa152&scoped=true&"
import script from "./segmented-control.vue?vue&type=script&lang=js&"
export * from "./segmented-control.vue?vue&type=script&lang=js&"
import style0 from "./segmented-control.vue?vue&type=style&index=0&id=b85fa152&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b85fa152",
  null
  
)

export default component.exports